import { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FireIcon from "../../../components/Icon/FireIcon";
import LotoIcon from "../../../components/Icon/LotoIcon";
import MegaIcon from "../../../components/Icon/MegaIcon";
import QuinaIcon from "../../../components/Icon/QuinaIcon";
import Contexts from "../../../contexts/Contexts";
import GroupsFilterButton from "./GroupsFilterButton";

const GroupsFilter: React.FC<{}> = () => {
  const { globalGameFilter, setGlobalGameFilter } = useContext(Contexts);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  const handleFilterClick = (gameId: number | null) => {
    // 设置游戏过滤器
    setGlobalGameFilter(gameId);
    
    // 如果不在游戏页面，先跳转到游戏页面
    if (location.pathname !== "/") {
      navigate("/");
    }
  };
  
  return (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
      }}
      className="hidden-scroll"
    >
      <GroupsFilterButton
        label={t("header.all")}
        icon={<FireIcon size={"20px"} />}
        iconBgColor="#FEE8E8"
        borderColor="#FF0000"
        selected={globalGameFilter === null}
        onClick={() => handleFilterClick(null)}
      />
      <GroupsFilterButton
        label="Mega-Sena"
        onClick={() => handleFilterClick(1)}
        icon={<MegaIcon size={"20px"} />}
        iconBgColor="#D6F8DF"
        borderColor="#1FD34C"
        selected={globalGameFilter === 1}
      />
      <GroupsFilterButton
        label="Quina"
        onClick={() => handleFilterClick(3)}
        icon={<QuinaIcon size={"20px"} />}
        iconBgColor="#F3D9FF"
        borderColor="#C848FF"
        selected={globalGameFilter === 3}
      />
      <GroupsFilterButton
        label="Lotofácil"
        onClick={() => handleFilterClick(2)}
        icon={<LotoIcon size={"20px"} />}
        iconBgColor="#FFF3D6"
        borderColor="#FFBD4B"
        selected={globalGameFilter === 2}
      />
    </div>
  );
};
export default GroupsFilter;
